/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    OrderMenuItem,
    OrderMenuItemFromJSON,
    OrderMenuItemToJSON,
    OrderMenuItemDataFrame,
    OrderMenuItemDataFrameFromJSON,
    OrderMenuItemDataFrameToJSON,
} from '../models';

export interface ApiOrderMenuItemsGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiOrderMenuItemsIdDeleteRequest {
    id: number;
}

export interface ApiOrderMenuItemsIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiOrderMenuItemsPostRequest {
    relations?: string;
    deleted?: boolean;
    orderMenuItem?: OrderMenuItem;
}

/**
 * no description
 */
export class OrderMenuItemApi extends runtime.BaseAPI {

    /**
     * Get list of OrderMenuItem
     */
    async apiOrderMenuItemsGetRaw(requestParameters: ApiOrderMenuItemsGetRequest): Promise<runtime.ApiResponse<OrderMenuItemDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderMenuItems`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMenuItemDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of OrderMenuItem
     */
    async apiOrderMenuItemsGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<OrderMenuItemDataFrame> {
        const response = await this.apiOrderMenuItemsGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of OrderMenuItem
     */
    async apiOrderMenuItemsIdDeleteRaw(requestParameters: ApiOrderMenuItemsIdDeleteRequest): Promise<runtime.ApiResponse<OrderMenuItem>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiOrderMenuItemsIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderMenuItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMenuItemFromJSON(jsonValue));
    }

    /**
     * Remove entity of OrderMenuItem
     */
    async apiOrderMenuItemsIdDelete(id: number): Promise<OrderMenuItem> {
        const response = await this.apiOrderMenuItemsIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of OrderMenuItem
     */
    async apiOrderMenuItemsIdGetRaw(requestParameters: ApiOrderMenuItemsIdGetRequest): Promise<runtime.ApiResponse<OrderMenuItem>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiOrderMenuItemsIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderMenuItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMenuItemFromJSON(jsonValue));
    }

    /**
     * Get entity of OrderMenuItem
     */
    async apiOrderMenuItemsIdGet(id: number, relations?: string, deleted?: boolean): Promise<OrderMenuItem> {
        const response = await this.apiOrderMenuItemsIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of OrderMenuItem (if id defined)
     */
    async apiOrderMenuItemsPostRaw(requestParameters: ApiOrderMenuItemsPostRequest): Promise<runtime.ApiResponse<OrderMenuItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderMenuItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderMenuItemToJSON(requestParameters.orderMenuItem),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMenuItemFromJSON(jsonValue));
    }

    /**
     * Create or update entity of OrderMenuItem (if id defined)
     */
    async apiOrderMenuItemsPost(relations?: string, deleted?: boolean, orderMenuItem?: OrderMenuItem): Promise<OrderMenuItem> {
        const response = await this.apiOrderMenuItemsPostRaw({ relations: relations, deleted: deleted, orderMenuItem: orderMenuItem });
        return await response.value();
    }

}
